<template>
  <div class="lotteryFail" v-if="failMessage">
    <div
      :style="{backgroundImage: 'url('+failImg+')'}"
      class="lotteryFail-icon"></div>
    <div class="lotteryFail-title">{{failMessage.title}}</div>
    <div :class="['lotteryFail-message', {'two-row': failMessage.title}]">{{failMessage.message}}</div>
    <div
      @click="btnHandle"
      class="lotteryFail-btn"
      v-if="failMessage.btnText">{{failMessage.btnText}}</div>
  </div>
</template>

<script>
import { lx } from '@/analytic/index';
import { env } from '@/common/env';
import { lxConfig } from '@/analytic/profilePhoto';
import { lotteryActivityId } from '@/common/config';

export default {
  props: {
    failMessage: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    lx.pv(lxConfig.lottery_fail_pv, {
      from: env.from || -999,
      activity_id: env.actGroupName || lotteryActivityId,
      city_id: -999,
      return_result: (this.failMessage && this.failMessage.title) || -999
    });
    if (this.failMessage && this.failMessage.btnText) {
      lx.mv(lxConfig.lottery_fail_btn_mv, {
        from: env.from || -999,
        activity_id: env.actGroupName || lotteryActivityId,
        city_id: -999,
        return_result: (this.failMessage && this.failMessage.title) || -999
      }, {
        cid: lxConfig.lottery_fail_pv
      });
    }
  },
  computed: {
    failImg() {
      if ([400000, 400001, 400002].includes(this.failMessage.errorCode)) {
        return 'https://p0.meituan.net/wxapp/1308ef8619f85a57dc7b8dd19307faff11994.png';
      }
      if (this.failMessage.errorCode === 400006) {
        return 'https://p0.meituan.net/wxapp/6e02500343593884ef26651029ebaf1124440.png';
      }
      return 'https://p0.meituan.net/wxapp/d72a4af39e0cd435152e7b14edd0613e15298.png';
    }
  },
  methods: {
    btnHandle() {
      lx.mc(lxConfig.lottery_fail_btn_mc, {
        from: env.from || -999,
        activity_id: env.actGroupName || lotteryActivityId,
        city_id: -999,
        return_result: (this.failMessage && this.failMessage.title) || -999
      }, {
        cid: lxConfig.lottery_fail_pv
      });
      if (!env.isInMeituan && !env.isInWaimai) {
        location.href = 'https://i.meituan.com/c/MTk1MGViMjQt';
        return;
      }
      this.$bridge.openPage(this.failMessage && this.failMessage.url);
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../styles/fn.less";
.lotteryFail {
  margin: 6.35rem 0.3rem 0.76rem 0.3rem;
  width: 6.9rem;
  height: 5.96rem;
  border-radius: 0.33rem;
  background: #FFFAEE;
  overflow:hidden;
  position: relative;
  padding: 0 0.47rem;
  .lotteryFail-icon {
    margin: 0.65rem auto auto;
    width: 2.79rem;
    height: 1.89rem;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .lotteryFail-title {
    font-family: PingFangSC-Semibold;
    font-size: 0.36rem;
    color: #121212;
    font-weight: 600;
    text-align: center;
    margin-bottom: -0.11rem;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .lotteryFail-message {
    margin-top: 0.2rem;
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: #919191;
    text-align: center;
    font-weight: 400;
    overflow:hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .two-row {
    -webkit-line-clamp: 2;
  }
  .lotteryFail-btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0.27rem;
    margin: auto;
    width: 5.82rem;
    height: 1.62rem;
    .bg-image-auto('https://p1.meituan.net/wxapp/5d362dde9f9b08d354fc8f2efa7333dd17889.png');
    font-family: PingFangSC-Semibold;
    font-size: 0.34rem;
    color: #5D1B06;
    text-align: center;
    font-weight: 600;
    padding-top: 0.29rem;
  }
}
</style>
